export default {
	HOME: 'Home',
	BACK: 'Back',
};
